import { signOut } from 'aws-amplify/auth';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FiSettings } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Flex,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import ButtonCircle from '@/components/buttons/ButtonCircle';
import UserIcon from '@/components/UserIcon';
import { useUserAuthenticationContext } from '@/features/userAuth/context/UserAuthenticationContext';
import { ROUTES } from '@/routes/Routes';
import { LivelinxLogo } from '@/ui/Logo';
import { reloadApp } from '@/utils/reloadApp';

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { email, isAdmin } = useUserAuthenticationContext();

  const handleSignOut = useCallback(() => {
    signOut({ global: false }).then(() => {
      navigate(ROUTES.HOME);
      reloadApp();
    });
  }, [navigate]);

  const handlebackToHomeClick = useCallback(() => {
    navigate(ROUTES.HOME);
  }, [navigate]);

  return (
    <Flex
      background="#FFF"
      padding="10px"
      justifyContent="space-between"
      rowGap="10px"
      marginLeft="-5px"
      marginRight="-5px"
      px="20px"
      userSelect="none"
    >
      {/* LEFT part */}
      <HStack>
        <Link to={ROUTES.HOME} reloadDocument>
          <LivelinxLogo />
        </Link>
      </HStack>

      {/* RIGHT part */}
      <HStack>
        {isAdmin && (
          <Link to={ROUTES.ADMIN} draggable="false">
            <HStack
              borderRadius="15px"
              gap="-5px"
              bg="livelinx.blue50"
              pl="15px"
              pr="3px"
              color="livelinx.purple200"
            >
              <Text>Admin</Text>
              <ButtonCircle
                bg="none"
                aria-label="settings-button"
                icon={<FiSettings color="livelinx.purple200" />}
              />
            </HStack>
          </Link>
        )}
        (
        <Popover>
          <PopoverTrigger>
            <ButtonCircle bg="none" aria-label="user-button" icon={<UserIcon username={email} />} />
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverBody>
              <Box>
                <Text>{`${t('admin.header.profile.greetUser')}, ${email}`}</Text>

                {isAdmin && (
                  <Text fontWeight="bold" color="primary">
                    🚀 You are admin
                  </Text>
                )}

                <Flex justifyContent="space-between" paddingTop="20px">
                  <Flex>
                    <Button
                      variant="blue"
                      fontWeight="normal"
                      onClick={() => {
                        handlebackToHomeClick();
                      }}
                      size="sm"
                    >
                      {t('admin.header.profile.goBack.button')}
                    </Button>
                  </Flex>
                  <Flex>
                    <Button
                      variant="solid"
                      border="1px"
                      borderColor="primary"
                      background="none"
                      color="primary"
                      size="sm"
                      onClick={handleSignOut}
                    >
                      {t('profile.signout.button')}
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        )
      </HStack>
    </Flex>
  );
};

export default Header;
